import { toast } from 'react-toastify';
export var min = 0;
export var max = 200;
export const ratings = [
    { value: '1', label: 1 },
    { value: '2', label: 2 },
    { value: '3', label: 3 },
    { value: '4', label: 4 },
    { value: '5', label: 5 },
];

export const sortBy = [
    { label: "Price: high to low", value: { field: "price", order: "desc" } },
    { label: "Price: low to high", value: { field: "price", order: "asc" } },
    { label: "Rating: high to low", value: { field: "rating", order: "desc" } },
    { label: "Rating: low to high", value: { field: "rating", order: "asc" } },
    {
        label: "Date: high to low",
        value: { field: "createdBy", order: "desc" },
    },
    { label: "Date: low to high", value: { field: "createdBy", order: "asc" } },
];
export const toast_error = {
    hideProgressBar: true,
    closeButton: false,
    position: toast.POSITION.TOP_CENTER,
};

export const toast_success = {
    hideProgressBar: true,
    closeButton: false,
    position: toast.POSITION.TOP_CENTER,
};

export const toast_warning = {
    hideProgressBar: true,
    closeButton: false,
    position: toast.POSITION.TOP_CENTER,
};

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const MIN_CHARGEABLE_AMOUNT = 50;
